import { Box, Button, Chip, TableCell, TableRow, Tooltip } from "@mui/material"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { trackActivity } from "../../../utils/mixpanel";
import { PermissionWrapper } from "../../../wrappers";
import { dateMonthYearDateFormat } from "../../../constants";
import moment from "moment";
import AuditPopover from "../../../shared_elements/components/popover";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { numberWithCommas } from "../../../utils";
const ClaimsLabel = ({ item }) => {
    const statusValue = item.status.value && item?.payout_status?.value && (item?.payout_status?.value === 4 || item?.payout_status?.value === 5 || item?.payout_status?.value === 6) ? item?.payout_status?.value : item.status.value;

    return (
        <Button variant="contained" className={`claims-status-${statusValue}`}
            sx={{
                textTransform: "capitalize",
                padding: "0 6px",
                fontWeight: "600",
                alignItems: "center",
                fontSize: "13px",
                whiteSpace: "nowrap",
                width: "120px",
                justifyContent: "center",
                "& .MuiButton-endIcon": {
                    marginLeft: "0px",
                },
            }} >{(item?.payout_status?.value === 4 || item?.payout_status?.value === 5 || item?.payout_status?.value === 6) ? item?.payout_status?.label : item?.status?.label ? item?.status?.label : '-- '}</Button>
    )
}

const sumPrsvAmount = (prsvAmount) => {
    if (!prsvAmount) return 0;
    return Object.values(prsvAmount).reduce((sum, value) => (
        sum + (value && typeof value === 'object' ? Object.values(value).reduce((s, v) => s + (v || 0), 0) : (value || 0))
    ), 0);
}

const sumClaimEventsAmount = (claimEvents, field) => {
    if (!Array.isArray(claimEvents)) return 0;
    return claimEvents.reduce((total, ev) => {
        if (ev?.maintenance_program?.is_llp_event === false && Array.isArray(ev?.modules) && ev.modules.length > 0) {
            const modulesTotal = ev.modules.reduce((s, mod) => s + Number(mod?.[field] || 0), 0);
            return total + modulesTotal;
        }
        return total + Number(ev?.[field] || 0);
    }, 0);
}

const ClaimManagementListing = ({ item, onView }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Claim Management Listing`, page_type: page_type, })
    }
    const isEngine = item?.shop_visit?.asset_type === 2;
    const prsvTotal = sumPrsvAmount(item?.prsv_amount_paid);
    const prsvClaimTotal = sumPrsvAmount(item?.prsv_claim_amount);
    const updatedAmount = isEngine
        ? sumClaimEventsAmount(item?.claim_events, 'amount_paid')
        : (item?.prsv_amount_paid || item?.llp_amount_paid) ? Number(item?.llp_amount_paid || 0) + prsvTotal : Number(item?.amount_paid || 0)
    const updatedClaimAmount = isEngine
        ? sumClaimEventsAmount(item?.claim_events, 'claim_amount')
        : Number(item?.claim_amount || 0) + Number(item?.llp_claim_amount || 0) + prsvClaimTotal
    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="icon-container" >
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "maintenance_claims", operationType: ['R'] }}>
                        <Tooltip title="View">
                            <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.shop_visit?.major_assembly?.name ? item?.shop_visit?.major_assembly?.name : '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>
                {item?.shop_visit?.asset_type === 2 ? (
                    Array.isArray(item?.claim_events) && item.claim_events.length > 0 ? (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                            {item.claim_events.map((ev) => {
                                const label = ev?.maintenance_program?.name || "";
                                const solutionType = ev?.maintenance_program?.is_llp_event === false ? "PRSV" : "LLP";
                                return (
                                    <Tooltip key={ev?.id} title={`${solutionType}${label ? ` - ${label}` : ""}`} placement="top" arrow>
                                        <Chip
                                            label={label}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                fontSize: '10px',
                                                height: '18px',
                                                maxWidth: 100,
                                                "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                                            }}
                                        />
                                    </Tooltip>
                                );
                            })}
                        </Box>
                    ) : '--'
                ) : (item?.shop_visit?.maintenance_check?.name || item?.shop_visit?.name || '--')}
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.submission_date ? moment(item?.submission_date).format(dateMonthYearDateFormat) : '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>   {item?.shop_visit?.cost ?
                <div >
                    {`${item?.currency ? item?.currency + numberWithCommas(Number(item?.shop_visit?.cost).toFixed(2)) : "US$" + numberWithCommas(Number(item?.shop_visit?.cost).toFixed(2))}`}
                </div>
                :
                'US$0.00'
            }</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{<ClaimsLabel item={item} />}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}> {(isEngine ? updatedClaimAmount : (item?.claim_amount || item?.llp_claim_amount || item?.prsv_claim_amount)) ?
                <div >
                    {`${item?.currency ? item?.currency + numberWithCommas(Number(updatedClaimAmount).toFixed(2)) : "US$" + numberWithCommas(Number(updatedClaimAmount).toFixed(2))}`}
                </div>
                : 'US$0.00'
            }
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>  {(isEngine ? updatedAmount : (item?.amount_paid || item?.llp_amount_paid || item?.prsv_amount_paid)) ?
                <div >
                    {`${item?.currency ? item?.currency + numberWithCommas(Number(updatedAmount).toFixed(2)) : "US$" + numberWithCommas(Number(updatedAmount).toFixed(2))}`}
                </div>
                : 'US$0.00'
            }</TableCell>
        </TableRow>
    )
}
export default ClaimManagementListing;